import React from "react";
import { Brain, Mic, ScanEye, Sparkles, TriangleAlert } from "lucide-react";
import { motion } from "framer-motion";
import PageHero from "../components/common/PageHero";
import StatGrid from "../components/common/StatGrid";

export default function AIInsights() {
  return (
    <div className="erp-page-grid">
      <PageHero
        badge="AI layer"
        title="Smarter insights with a calmer, cleaner presentation."
        subtitle="Forecasts, risk signals and pricing suggestions now live inside a lighter executive workspace instead of a flashy dashboard shell."
        actions={
          <>
            <motion.button className="erp-btn erp-btn-ghost" whileTap={{ scale: 0.97 }}>
              <Mic size={15} /> Voice entry
            </motion.button>
            <motion.button className="erp-btn erp-btn-ghost" whileTap={{ scale: 0.97 }}>
              <ScanEye size={15} /> Quality vision
            </motion.button>
            <motion.button className="erp-btn erp-btn-primary" whileTap={{ scale: 0.97 }}>
              <Brain size={15} /> Run insights
            </motion.button>
          </>
        }
      />

      <StatGrid
        items={[
          {
            title: "Forecasts",
            value: "14",
            meta: "Fresh signals generated today",
            trend: "New",
            tone: "success",
            icon: Brain,
          },
          {
            title: "Risk alerts",
            value: "6",
            meta: "Need review",
            trend: "Attention",
            tone: "warning",
            icon: TriangleAlert,
          },
          {
            title: "Rate suggestions",
            value: "18",
            meta: "Auto-generated opportunities",
            trend: "Ready",
            tone: "success",
            icon: Sparkles,
          },
          {
            title: "Worker anomalies",
            value: "2",
            meta: "Pattern deviation detected",
            trend: "Watch",
            tone: "warning",
            icon: ScanEye,
          },
        ]}
      />

      <div className="erp-grid erp-grid-3">
        {[
          [
            "Demand forecast",
            "3mm premium oval may tighten in 7 days due to dispatch trend.",
          ],
          [
            "Loss intelligence",
            "Two MM workers are above the safe weekly rejection band.",
          ],
          [
            "Rate suggestion",
            "Grade A polished dispatches may support 4–6% higher pricing.",
          ],
          [
            "Bottleneck detection",
            "MM backlog remains the most active constraint in the chain.",
          ],
          [
            "Approval risk",
            "Agent B shows high return tendency on medium grade lots.",
          ],
          [
            "Smart reorder",
            "Suggested raw purchase in amethyst input category within 5 days.",
          ],
        ].map(([title, desc]) => (
          <motion.section
            className="erp-card"
            key={title}
            whileHover={{ y: -4 }}
            whileTap={{ scale: 0.985 }}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <div className="erp-card-head">
              <div>
                <h3>{title}</h3>
                <p>{desc}</p>
              </div>
              <Sparkles size={18} />
            </div>
          </motion.section>
        ))}
      </div>

      <div className="erp-card">
        <div className="erp-card-head">
          <div>
            <h3>Recommendation stream</h3>
            <p>Suggested next steps shown in a clearer, more business-first interface.</p>
          </div>
        </div>
        <div className="erp-list">
          {[
            ["Push premium assorting", "High-grade finish lots are ready for better realization."],
            ["Rebalance MM workers", "A minor reallocation may reduce queue time by afternoon."],
            ["Review Agent B portfolio", "Return pattern suggests a tighter approval mix."],
          ].map(([title, text]) => (
            <div key={title} className="erp-list-row">
              <div className="erp-list-icon">
                <Sparkles size={14} />
              </div>
              <div>
                <strong>{title}</strong>
                <p>{text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
